import { createPrismModel, createRectTubeModel } from "./createModel";
import { McGePoint3d, McDbPolyline, McCmColor, McGeVector3d } from "mxcad";
import { MovePt } from "../operate/structural";
//计算梁绘制数据
export const getPKPM_BeamData = (
  nModelShapeType,
  strShapeData,
  dStPtX,
  dStPtY,
  dEdPtX,
  dEdPtY,
  dBotEle,
  dFloorHeight,
  dEcc,
  dHDiff1,
  dHDiff2,
  dRotation,
  isArc,
  ptCenter,
  dRadius,
  stJointHDiff,
  edJointHDiff
) => {
  let strRes = "";
  if (nModelShapeType < 0) {
    return strRes;
  }
  if (!strShapeData) {
    return strRes;
  }
  let vecModelSizeData = strShapeData.split(",");

  const nSize = vecModelSizeData.length;
  if (nSize < 3) {
    return strRes;
  }
  // Calculate positions
  let pt1 = { x: dStPtX, y: dStPtY, z: dHDiff1 + dFloorHeight };
  let pt2 = { x: dEdPtX, y: dEdPtY, z: dHDiff2 + dFloorHeight };
  const dLength = distance(pt1, pt2);
  if (dHDiff1 === dHDiff2 && dHDiff2 === 0) {
    pt1.z = dBotEle + dFloorHeight;
    pt2.z = dBotEle + dFloorHeight;
  } else {
    // Slanted beam logic here (not implemented in the original code)
    pt1.z = dHDiff1 + dFloorHeight;
    pt2.z = dHDiff2 + dFloorHeight;
  }

  if (stJointHDiff) {
    pt1.z += stJointHDiff;
  }
  if (edJointHDiff) {
    pt2.z += edJointHDiff;
  }

  const dirLen = { x: pt2.x - pt1.x, y: pt2.y - pt1.y, z: pt2.z - pt1.z };
  const dirWidth = crossProduct(dirLen, { x: 0, y: 0, z: 1 });
  //dirLen取单位向量
  let lenLen = Math.sqrt(dirLen.x * dirLen.x + dirLen.y * dirLen.y);
  const vecLen = {
    x: dirLen.x / lenLen,
    y: dirLen.y / lenLen,
    z: dirLen.z / lenLen,
  };
  //dirWidth取单位向量
  let lenWidth = Math.sqrt(dirWidth.x * dirWidth.x + dirWidth.y * dirWidth.y);
  const vecWidth = {
    x: dirWidth.x / lenWidth,
    y: dirWidth.y / lenWidth,
    z: dirWidth.z / lenWidth,
  };

  if (!isArc && Math.abs(dEcc) > 0) {
    let dirReverse = false;
    if (pt1.x - pt2.x > 1 || pt1.y - pt2.y > 1) dirReverse = true;

    //指向右上方
    if (
      !dirReverse ||
      (Math.abs(vecWidth.x - 1) < Math.exp(-2) &&
        Math.abs(vecWidth.y) < Math.exp(-2)) ||
      (Math.abs(vecWidth.x) < Math.exp(-2) &&
        Math.abs(vecWidth.y - 1) < Math.exp(-2))
    ) {
      pt1.x -= Math.abs(vecWidth.x) * dEcc;
      pt1.y += Math.abs(vecWidth.y) * dEcc;
    } else if (dirReverse && vecWidth.x < 0) {
      pt1.x += Math.abs(vecWidth.x) * dEcc;
      pt1.y += Math.abs(vecWidth.y) * dEcc;
    } else {
      //左下方
      pt1.x -= Math.abs(vecWidth.x) * dEcc;
      pt1.y -= Math.abs(vecWidth.y) * dEcc;
    }

    // pt1.z -= Math.abs(dirWidth.z) * dEcc; // This line is commented out in the C++ version
  }

  const dWidth = parseFloat(vecModelSizeData[1]);
  const dHeight = parseFloat(vecModelSizeData[2]);

  let pt0 = {
    x: pt1.x + (vecWidth.x * dWidth) / 2,
    y: pt1.y + (vecWidth.y * dWidth) / 2,
    z: pt1.z + (vecWidth.z * dWidth) / 2,
  };

  // Handling the shape type and size
  switch (nModelShapeType) {
    case 1: // Rectangle
      if (nSize === 5) {
        if (isArc) {
          strRes = getArcModelDesignData(
            "modelWall",
            pt1,
            pt2,
            ptCenter,
            dRadius,
            dHeight,
            dWidth,
            dEcc
          );
        } else {
          strRes = getRectModelDesignData(
            "modelBeam",
            pt0,
            vecLen,
            { x: -vecWidth.x, y: -vecWidth.y, z: -vecWidth.z },
            dWidth,
            dLength,
            dHeight,
            dRotation,
            pt1,
            vecLen
          );
        }
      }
      break;

    case 2: // I-beam
      if (nSize === 9) {
        const dB = parseFloat(vecModelSizeData[1]);
        const dH = parseFloat(vecModelSizeData[2]);
        const dU = parseFloat(vecModelSizeData[3]);
        const dT = parseFloat(vecModelSizeData[4]);
        const dD = parseFloat(vecModelSizeData[5]);
        const dF = parseFloat(vecModelSizeData[6]);
        strRes = getIShapeDesignData(
          pt0,
          { x: -vecWidth.x, y: -vecWidth.y, z: -vecWidth.z },
          { x: 0, y: 0, z: 1 },
          dB,
          dH,
          dU,
          dT,
          dD,
          dF,
          dLength,
          dRotation,
          pt1,
          vecLen
        );
      }
      break;

    case 3: // Circle
      if (nSize === 4) {
        const dDiameter = parseFloat(vecModelSizeData[1]);
        strRes = getCircleDesignData(pt1, dDiameter / 2, dLength, vecLen);
      }
      break;

    case 4: // Regular polygon
      if (nSize === 5) {
        const dDiameter = parseFloat(vecModelSizeData[1]);
        const nCount = parseInt(vecModelSizeData[2]);
        strRes = getRegularPolygonDesignData(
          pt1,
          dDiameter / 2,
          nCount,
          dLength,
          0,
          vecLen
        );
      }
      break;

    case 10: // Cross I-beam
      if (nSize === 11) {
        const dB = parseFloat(vecModelSizeData[1]);
        const dH = parseFloat(vecModelSizeData[2]);
        const dT = parseFloat(vecModelSizeData[3]);
        const dF = parseFloat(vecModelSizeData[4]);
        const dU = parseFloat(vecModelSizeData[5]);
        const dD = parseFloat(vecModelSizeData[6]);
        const dL = parseFloat(vecModelSizeData[7]);
        const dP = parseFloat(vecModelSizeData[8]);
        strRes = getCrossIShapeDesignData(
          pt1,
          { x: -vecWidth.x, y: -vecWidth.y, z: -vecWidth.z },
          { x: 0, y: 0, z: 1 },
          dB,
          dH,
          dT,
          dF,
          dU,
          dD,
          dL,
          dP,
          dLength,
          dRotation,
          vecLen
        );
      }
      break;

    case 7: // Box shape
      if (nSize >= 7) {
        const dRectWidth = parseFloat(vecModelSizeData[1]);
        const dRectLength = parseFloat(vecModelSizeData[2]);
        const dThickTop = parseFloat(vecModelSizeData[3]);
        const dThickLeft = parseFloat(vecModelSizeData[4]);
        const dThickBot = dThickTop;
        const dThickRight = dThickLeft;
        strRes = getRectTubeDesignData(
          pt1,
          { x: -vecWidth.x, y: -vecWidth.y, z: -vecWidth.z },
          { x: 0, y: 0, z: 1 },
          dRectWidth,
          dRectLength,
          dThickTop,
          dThickLeft,
          dThickBot,
          dThickRight,
          dLength,
          dRotation,
          vecLen
        );
      }
      break;

    case 8: // Round pipe
      // No implementation yet
      break;

    case 21: // Rectangle variable cross-section
      if (nSize === 6) {
        const dB = parseFloat(vecModelSizeData[1]);
        const dH1 = parseFloat(vecModelSizeData[2]);
        const dH2 = parseFloat(vecModelSizeData[3]);
        if (pt1.x > pt2.x || pt1.y > pt2.y) {
          pt0 = {
            x: pt2.x + (vecWidth.x * dWidth) / 2,
            y: pt2.y + (vecWidth.y * dWidth) / 2,
            z: pt2.z + (vecWidth.z * dWidth) / 2,
          };
          vecLen.x = -vecLen.x;
          vecLen.y = -vecLen.y;
        }
        strRes = getIrrRectDesignData(
          pt0,
          vecLen,
          { x: 0, y: 0, z: -1 },
          dLength,
          dH2,
          dH1,
          dB,
          { x: -vecWidth.x, y: -vecWidth.y, z: -vecWidth.z }
        );
      }
      break;
    case 26: // 型钢
      if (nSize === 11) {
        if (Number(vecModelSizeData[1]) == 39) {
          //H型--和工字型一致
          const dHH = parseFloat(vecModelSizeData[3]);
          const dB1 = parseFloat(vecModelSizeData[5]);
          const dTW = parseFloat(vecModelSizeData[7]);
          const dTF = parseFloat(vecModelSizeData[6]);
          strRes = getIShapeDesignData(
            pt0,
            { x: -vecWidth.x, y: -vecWidth.y, z: -vecWidth.z },
            { x: 0, y: 0, z: 1 },
            dTW,
            dHH,
            dB1,
            dTF,
            dB1,
            dTF,
            dLength,
            dRotation,
            pt1,
            vecLen
          );
        } else if (Number(vecModelSizeData[1]) == 33) {
          //L型
          const dB2 = parseFloat(vecModelSizeData[3]);
          const dT2 = parseFloat(vecModelSizeData[6]);
          strRes = getSteelLShapeDesignData(
            pt1,
            { x: -vecWidth.x, y: -vecWidth.y, z: -vecWidth.z },
            { x: 0, y: 0, z: 1 },
            dB2,
            dT2,
            dLength,
            dRotation,
            vecLen
          );
        }
      }

      break;

    default:
      break;
  }

  return strRes;
};

//计算隔墙绘制数据
export const getPKPM_PartitionWallData = (
  nModelShapeType,
  nWallThick,
  dStPtX,
  dStPtY,
  dEdPtX,
  dEdPtY,
  dBotEle,
  dFloorHeight,
  dEcc,
  isArc,
  ptCenter,
  dRadius,
  stJointHDiff,
  edJointHDiff
) => {
  let strRes = "";

  // 参数检查
  if (nModelShapeType < 0 || nWallThick <= 0) {
    return strRes;
  }
  let dHeight = dFloorHeight;
  // 计算位置
  let pt1 = { x: dStPtX, y: dStPtY, z: dBotEle + dHeight };
  let pt2 = { x: dEdPtX, y: dEdPtY, z: dBotEle + dHeight };
  let dLength = distance(pt1, pt2);
  // if (stJointHDiff) {
  //   pt1.z += stJointHDiff;
  // }
  // if (edJointHDiff) {
  //   pt2.z += edJointHDiff;
  // }

  let dirLen = {
    x: pt2.x - pt1.x,
    y: pt2.y - pt1.y,
    z: pt2.z - pt1.z,
  };
  let dirWidth = crossProduct(dirLen, { x: 0, y: 0, z: 1 });
  //dirLen,dirWidth取单位向量
  let lenDirLen = Math.sqrt(dirLen.x * dirLen.x + dirLen.y * dirLen.y);
  dirLen = {
    x: dirLen.x / lenDirLen,
    y: dirLen.y / lenDirLen,
    z: dirLen.z / lenDirLen,
  };
  let lenDirWidth = Math.sqrt(
    dirWidth.x * dirWidth.x + dirWidth.y * dirWidth.y
  );
  dirWidth = {
    x: dirWidth.x / lenDirWidth,
    y: dirWidth.y / lenDirWidth,
    z: dirWidth.z / lenDirWidth,
  };

  // 如果偏心量不为0，调整 pt1
  if (!isArc && Math.abs(dEcc) > 0) {
    let dirReverse = false;
    if (pt1.x - pt2.x > 1 || pt1.y - pt2.y > 1) dirReverse = true;
    //指向右上方
    if (
      !dirReverse ||
      (Math.abs(dirWidth.x - 1) < Math.exp(-2) &&
        Math.abs(dirWidth.y) < Math.exp(-2)) ||
      (Math.abs(dirWidth.x) < Math.exp(-2) &&
        Math.abs(dirWidth.y - 1) < Math.exp(-2))
    ) {
      pt1.x -= Math.abs(dirWidth.x) * dEcc;
      pt1.y += Math.abs(dirWidth.y) * dEcc;
    } else {
      pt1.x -= Math.abs(dirWidth.x) * dEcc;
      pt1.y -= Math.abs(dirWidth.y) * dEcc;
    }
    // pt1.Z -= Math.abs(dirWidth.Z) * dEcc; // Z轴调整被注释掉
  }

  // 计算 pt0
  let pt0 = {
    x: pt1.x - (dirWidth.x * nWallThick) / 2,
    y: pt1.y - (dirWidth.y * nWallThick) / 2,
    z: pt1.z - (dirWidth.z * nWallThick) / 2,
  };

  if (stJointHDiff !== 0 || edJointHDiff !== 0) {
    pt0.z -= dHeight;
    strRes = getIrrRectDesignData(
      pt0,
      dirLen,
      { x: 0, y: 0, z: 1 },
      dLength,
      dHeight + stJointHDiff,
      dHeight + edJointHDiff,
      nWallThick,
      dirWidth
    );
  } else if (nModelShapeType === 1 && !isArc) {
    strRes = getRectModelDesignData(
      "modelWall",
      pt0,
      dirLen,
      dirWidth,
      nWallThick,
      dLength,
      dHeight
    );
  } else if (nModelShapeType === 1 && isArc) {
    strRes = getArcModelDesignData(
      "modelWall",
      pt1,
      pt2,
      ptCenter,
      dRadius,
      dHeight,
      nWallThick,
      dEcc
    );
  }

  return strRes;
};

//计算墙绘制数据
export const getPKPM_WallData = (
  nModelShapeType,
  nWallThick,
  dStPtX,
  dStPtY,
  dEdPtX,
  dEdPtY,
  dBotEle,
  dFloorHeight,
  dEcc,
  dHDiff1,
  dHDiff2,
  dHDiffB,
  dHeight,
  isArc,
  ptCenter,
  dRadius,
  stJointHDiff,
  edJointHDiff
) => {
  let strRes = "";

  // 参数检查
  if (nModelShapeType < 0 || nWallThick <= 0) {
    return strRes;
  }

  // 如果 dHeight 为0，设置为 dFloorHeight
  if (dHeight === 0) {
    dHeight = dFloorHeight;
  }

  // 计算位置
  let pt1 = { x: dStPtX, y: dStPtY, z: dBotEle + dHeight };
  let pt2 = { x: dEdPtX, y: dEdPtY, z: dBotEle + dHeight };
  let dLength = distance(pt1, pt2);
  // if (stJointHDiff) {
  //   pt1.z += stJointHDiff;
  // }
  // if (edJointHDiff) {
  //   pt2.z += edJointHDiff;
  // }
  let dirLen = {
    x: pt2.x - pt1.x,
    y: pt2.y - pt1.y,
    z: pt2.z - pt1.z,
  };
  let dirWidth = crossProduct(dirLen, { x: 0, y: 0, z: 1 });
  //dirLen,dirWidth取单位向量
  let lenDirLen = Math.sqrt(dirLen.x * dirLen.x + dirLen.y * dirLen.y);
  dirLen = {
    x: dirLen.x / lenDirLen,
    y: dirLen.y / lenDirLen,
    z: dirLen.z / lenDirLen,
  };
  let lenDirWidth = Math.sqrt(
    dirWidth.x * dirWidth.x + dirWidth.y * dirWidth.y
  );
  dirWidth = {
    x: dirWidth.x / lenDirWidth,
    y: dirWidth.y / lenDirWidth,
    z: dirWidth.z / lenDirWidth,
  };

  // 如果偏心量不为0，调整 pt1
  if (!isArc && Math.abs(dEcc) > 0) {
    let dirReverse = false;
    if (pt1.x - pt2.x > 1 || pt1.y - pt2.y > 1) dirReverse = true;

    //指向右上方或正交
    if (
      !dirReverse ||
      (Math.abs(dirWidth.x - 1) < Math.exp(-2) &&
        Math.abs(dirWidth.y) < Math.exp(-2)) ||
      (Math.abs(dirWidth.x) < Math.exp(-2) &&
        Math.abs(dirWidth.y - 1) < Math.exp(-2))
    ) {
      pt1.x -= Math.abs(dirWidth.x) * dEcc;
      pt1.y += Math.abs(dirWidth.y) * dEcc;
    } else {
      pt1.x -= Math.abs(dirWidth.x) * dEcc;
      pt1.y -= Math.abs(dirWidth.y) * dEcc;
    }
    // pt1.Z -= Math.abs(dirWidth.Z) * dEcc; // Z轴调整被注释掉
  }

  // 计算 pt0
  let pt0 = {
    x: pt1.x - (dirWidth.x * nWallThick) / 2,
    y: pt1.y - (dirWidth.y * nWallThick) / 2,
    z: pt1.z - (dirWidth.z * nWallThick) / 2,
  };

  // 如果有变截面，使用变截面数据
  if (
    dHDiff1 !== 0 ||
    dHDiff2 !== 0 ||
    stJointHDiff !== 0 ||
    edJointHDiff !== 0
  ) {
    pt0.z -= dHeight;
    strRes = getIrrRectDesignData(
      pt0,
      dirLen,
      { x: 0, y: 0, z: 1 },
      dLength,
      dHDiff1 + dHeight + stJointHDiff,
      dHDiff2 + dHeight + edJointHDiff,
      nWallThick,
      dirWidth
    );
  } else if (nModelShapeType === 1 && !isArc) {
    strRes = getRectModelDesignData(
      "modelWall",
      pt0,
      dirLen,
      dirWidth,
      nWallThick,
      dLength,
      dHeight
    );
  } else if (nModelShapeType === 1 && isArc) {
    strRes = getArcModelDesignData(
      "modelWall",
      pt1,
      pt2,
      ptCenter,
      dRadius,
      dHeight,
      nWallThick,
      dEcc
    );
  }

  return strRes;
};

//计算柱绘制数据
export const getPKPM_ColData = (
  nModelShapeType,
  strShapeData,
  dPtX,
  dPtY,
  dBotEle,
  dFloorHeight,
  dHeight,
  dEccX,
  dEccY,
  dRotation,
  dHDiffB,
  dJointHDiff
) => {
  let strRes = "";
  if (nModelShapeType < 0 || !strShapeData) return strRes;

  let vecModelSizeData = strShapeData.split(",");

  const nSize = vecModelSizeData.length;
  if (nSize < 3) {
    return strRes;
  }

  if (dHDiffB === 0) {
    dHDiffB = dBotEle;
  }

  dHeight = dHeight + dJointHDiff;

  let pt = { x: dPtX, y: dPtY, z: dFloorHeight + dJointHDiff };

  let dirLen = { x: 1, y: 0, z: 0 };
  let dirWidth = { x: 0, y: 1, z: 0 };

  pt.x += dirLen.x * dEccX;
  pt.y += dirWidth.y * dEccY;
  if (nModelShapeType === 1 && nSize === 5) {
    // Rectangular
    let dThick = parseFloat(vecModelSizeData[1]);
    let dWidth = parseFloat(vecModelSizeData[2]);
    let pt0 = {
      x: pt.x - (dirLen.x * dThick) / 2,
      y: pt.y - (dirWidth.y * dWidth) / 2,
      z: pt.z,
    };
    strRes = getRectModelDesignData(
      "modelColum",
      pt0,
      dirLen,
      dirWidth,
      dWidth,
      dThick,
      dHeight,
      dRotation,
      { x: dPtX, y: dPtY, z: dHDiffB + dFloorHeight + dJointHDiff }
    );
  } else if (nModelShapeType === 2 && nSize === 9) {
    // I-beam
    let dB = parseFloat(vecModelSizeData[1]);
    let dH = parseFloat(vecModelSizeData[2]);
    let dU = parseFloat(vecModelSizeData[3]);
    let dT = parseFloat(vecModelSizeData[4]);
    let dD = parseFloat(vecModelSizeData[5]);
    let dF = parseFloat(vecModelSizeData[6]);
    strRes = getIShapeDesignData(
      pt,
      dirLen,
      dirWidth,
      dB,
      dH,
      dU,
      dT,
      dD,
      dF,
      dHeight,
      dRotation,
      { x: dPtX, y: dPtY, z: dHDiffB + dFloorHeight + dJointHDiff }
    );
  } else if (nModelShapeType === 3 && nSize === 4) {
    // Circular
    let dDiameter = parseFloat(vecModelSizeData[1]);
    strRes = getCircleDesignData(pt, dDiameter / 2, dHeight);
  } else if (nModelShapeType === 4 && nSize === 5) {
    // Regular Polygon
    let dDiameter = parseFloat(vecModelSizeData[1]);
    let nCount = parseInt(vecModelSizeData[2], 10);
    strRes = getRegularPolygonDesignData(pt, dDiameter / 2, nCount, dHeight, 0);
  } else if (nModelShapeType === 10 && nSize === 11) {
    // Cross I-beam
    let dB = parseFloat(vecModelSizeData[1]);
    let dH = parseFloat(vecModelSizeData[2]);
    let dT = parseFloat(vecModelSizeData[3]);
    let dF = parseFloat(vecModelSizeData[4]);
    let dU = parseFloat(vecModelSizeData[5]);
    let dD = parseFloat(vecModelSizeData[6]);
    let dL = parseFloat(vecModelSizeData[7]);
    let dP = parseFloat(vecModelSizeData[8]);
    strRes = getCrossIShapeDesignData(
      pt,
      dirWidth,
      { x: 0, y: 0, z: 1 },
      dB,
      dH,
      dT,
      dF,
      dU,
      dD,
      dL,
      dP,
      dHeight,
      dRotation
    );
  } else if (nModelShapeType === 7 && nSize >= 7) {
    // Box
    const dRectWidth = parseFloat(vecModelSizeData[1]);
    const dRectLength = parseFloat(vecModelSizeData[2]);
    const dThickTop = parseFloat(vecModelSizeData[3]);
    const dThickLeft = parseFloat(vecModelSizeData[4]);
    const dThickBot = dThickTop;
    const dThickRight = dThickLeft;
    strRes = getRectTubeDesignData(
      pt,
      dirWidth,
      { x: 0, y: 0, z: 1 },
      dRectWidth,
      dRectLength,
      dThickTop,
      dThickLeft,
      dThickBot,
      dThickRight,
      dHeight,
      dRotation
    );
  } else if (nModelShapeType === 28 && nSize === 7) {
    // L-shape
    let dB = parseFloat(vecModelSizeData[1]);
    let dH = parseFloat(vecModelSizeData[2]);
    let dD = parseFloat(vecModelSizeData[3]);
    let dF = parseFloat(vecModelSizeData[4]);

    strRes = getLShapeDesignData(pt, dB, dH, dD, dF, dHeight, dRotation, {
      x: 0,
      y: 0,
      z: -1,
    });
  } else if (nModelShapeType === 29 && nSize === 7) {
    // T-shape
    let dB = parseFloat(vecModelSizeData[1]);
    let dH = parseFloat(vecModelSizeData[2]);
    let dD = parseFloat(vecModelSizeData[3]);
    let dF = parseFloat(vecModelSizeData[4]);
    strRes = getTShapeDesignData(pt, dB, dH, dD, dF, dHeight, dRotation, {
      x: 0,
      y: 0,
      z: -1,
    });
  } else if (nModelShapeType === 26 && nSize === 11) {
    if (Number(vecModelSizeData[1]) == 39) {
      //H型--和工字型一致
      const dH1 = parseFloat(vecModelSizeData[3]);
      const dB1 = parseFloat(vecModelSizeData[5]);
      const dTW = parseFloat(vecModelSizeData[7]);
      const dTF = parseFloat(vecModelSizeData[6]);
      strRes = getIShapeDesignData(
        pt,
        dirLen,
        dirWidth,
        dTW,
        dH1,
        dB1,
        dTF,
        dB1,
        dTF,
        dHeight,
        dRotation,
        {
          x: 0,
          y: 0,
          z: -1,
        }
      );
    } else if (Number(vecModelSizeData[1]) == 33) {
      //L型
      const dB2 = parseFloat(vecModelSizeData[3]);
      const dT2 = parseFloat(vecModelSizeData[6]);
      strRes = getSteelLShapeDesignData(
        pt,
        dirLen,
        dirWidth,
        dB2,
        dT2,
        dHeight,
        dRotation,
        {
          x: 0,
          y: 0,
          z: -1,
        }
      );
    }
  }

  return strRes;
};

//计算板绘制数据
export const getPKPM_SlabData = (
  strVertexX,
  strVertexY,
  nStandardThickness,
  nThickness,
  dBotEle,
  dFloorHeight
) => {
  let strRes = "";

  if (!strVertexX || !strVertexY || nStandardThickness <= 0) return strRes;

  // Split the input strings into arrays
  let vecXData = strVertexX.split(",");
  let vecYData = strVertexY.split(",");
  //剔除数组中为空的数据
  vecXData = vecXData.filter((item) => item);
  vecYData = vecYData.filter((item) => item);

  // Check if the sizes match (you can remove the Z-related checks for now)
  let nSizeX = vecXData.length;
  let nSizeY = vecYData.length;
  if (nSizeX !== nSizeY || nSizeX < 3) return strRes;

  // Create points using the input data
  let dTopEle = dBotEle + dFloorHeight;
  let vecPtData = [];
  for (let i = 0; i < nSizeX; i++) {
    if (!vecXData[i] || !vecYData[i]) continue;

    vecPtData.push({
      x: parseFloat(vecXData[i]),
      y: parseFloat(vecYData[i]),
      z: dTopEle,
    });
  }

  // Set the thickness (default to standard thickness if invalid)
  if (nThickness === 9999 || nThickness <= 0) nThickness = nStandardThickness;

  // Assuming `getMakePrismModelData` is defined elsewhere
  let { upViewData, drawData } = getMakePrismModelData(
    vecPtData,
    vecPtData,
    nThickness
  );
  let ptTmp = vecPtData[0];
  let sectData = getSectData("H", nThickness, vecPtData[0], ptTmp);

  strRes = `{"upViewData":[${upViewData.replace(
    /"/g,
    ""
  )}],"SectData":[${sectData}],"Drawing_3D":${drawData}}`;

  // let strRes = JSON.stringify({
  //   upViewData: vecUpViewPtDataTmp,
  //   SectData: sectData,
  //   Drawing_3D: drawData,
  // });

  return strRes;
};

//计算悬挑板绘制数据
export const getPKPM_CantileverSlabData = (
  points,
  nStandardThickness,
  nThickness,
  dBotEle,
  dFloorHeight
) => {
  let strRes = "";

  if (!points || points.length <= 0 || nStandardThickness <= 0) return strRes;

  let nSize = points.length;
  if (nSize < 3) return strRes;

  // Create points using the input data
  let dTopEle = dBotEle + dFloorHeight;
  let vecPtData = [];
  for (let i = 0; i < nSize; i++) {
    if (!points[i]) continue;

    vecPtData.push({
      x: points[i].x,
      y: points[i].y,
      z: dTopEle,
    });
  }

  // Set the thickness (default to standard thickness if invalid)
  if (nThickness === 9999 || nThickness <= 0) nThickness = nStandardThickness;

  // Assuming `getMakePrismModelData` is defined elsewhere
  let { upViewData, drawData } = getMakePrismModelData(
    vecPtData,
    vecPtData,
    nThickness
  );
  let ptTmp = vecPtData[0];
  let sectData = getSectData("H", nThickness, vecPtData[0], ptTmp);

  strRes = `{"upViewData":[${upViewData.replace(
    /"/g,
    ""
  )}],"SectData":[${sectData}],"Drawing_3D":${drawData}}`;

  // let strRes = JSON.stringify({
  //   upViewData: vecUpViewPtDataTmp,
  //   SectData: sectData,
  //   Drawing_3D: drawData,
  // });

  return strRes;
};

//计算墙洞绘制数据
export const getPKPM_WallHoleData = (
  dStPtX,
  dStPtY,
  dEdPtX,
  dEdPtY,
  nHoleWidth,
  nHoleHeight,
  nWallThick,
  nWallEcc,
  Ecc,
  HDiff,
  nFloorBotEle
) => {
  let strRes = "";
  if (nHoleWidth <= 0 || nHoleHeight <= 0) {
    return strRes;
  }
  // Define points pt1 and pt2 using the provided coordinates
  let pt1 = { x: dStPtX, y: dStPtY, z: nFloorBotEle + HDiff + nHoleHeight };
  let pt2 = { x: dEdPtX, y: dEdPtY, z: nFloorBotEle + HDiff + nHoleHeight };

  // 如果pt1在pt2的左上方，则交换pt1和pt2
  if (dStPtX > dEdPtX && dStPtY > dEdPtY) {
    [pt1, pt2] = [pt2, pt1];
  } else if (dStPtX > dEdPtX && Math.abs(dStPtY - dEdPtY) < 0.1) {
    [pt1, pt2] = [pt2, pt1];
  } else if (dStPtY > dEdPtY && Math.abs(dStPtX - dEdPtX) < 0.1) {
    [pt1, pt2] = [pt2, pt1];
  }

  // 计算方向向量
  let dirLenTmp = { x: pt2.x - pt1.x, y: pt2.y - pt1.y, z: pt2.z - pt1.z };
  // 获取dirLen的单位向量
  let len = Math.sqrt(dirLenTmp.x * dirLenTmp.x + dirLenTmp.y * dirLenTmp.y);
  let dirLen = {
    x: dirLenTmp.x / len,
    y: dirLenTmp.y / len,
    z: dirLenTmp.z / len,
  };

  // 计算dirWidth
  let dirWidth = crossProduct(dirLen, { x: 0, y: 0, z: 1 });
  let dLength = distance(pt1, pt2);

  if (Ecc < 0) {
    Ecc += dLength;
    Ecc -= nHoleWidth;
  }

  if (Math.abs(nWallEcc) > 0) {
    pt1.x -= Math.abs(dirWidth.x) * nWallEcc;
    pt1.y += Math.abs(dirWidth.y) * nWallEcc;
  }

  // Calculate the distance from the start point for the wall hole
  let pt0 = {
    x: pt1.x - (dirWidth.x * nWallThick) / 2 + dirLen.x * Ecc,
    y: pt1.y - (dirWidth.y * nWallThick) / 2 + dirLen.y * Ecc,
    z: pt1.z - (dirWidth.z * nWallThick) / 2 + dirLen.z * Ecc,
  };

  // Assuming `getRectModelDesignData` is a function that you already have in JavaScript
  strRes = getRectModelDesignData(
    "modelWall",
    pt0,
    dirLen,
    dirWidth,
    nWallThick,
    nHoleWidth,
    nHoleHeight
  );

  return strRes;
};

//计算门窗绘制数据
export const getPKPM_DoorsWindowsData = (
  dStPtX,
  dStPtY,
  dEdPtX,
  dEdPtY,
  nHoleWidth,
  nHoleHeight,
  nWallThick,
  nWallEcc,
  Ecc,
  HDiff,
  nFloorBotEle
) => {
  let strRes = "";
  if (nHoleWidth <= 0 || nHoleHeight <= 0) {
    return strRes;
  }
  // Define points pt1 and pt2 using the provided coordinates
  let pt1 = { x: dStPtX, y: dStPtY, z: nFloorBotEle + HDiff + nHoleHeight };
  let pt2 = { x: dEdPtX, y: dEdPtY, z: nFloorBotEle + HDiff + nHoleHeight };

  // 如果pt1在pt2的左上方，则交换pt1和pt2
  if (dStPtX > dEdPtX && dStPtY > dEdPtY) {
    [pt1, pt2] = [pt2, pt1];
  } else if (dStPtX > dEdPtX && Math.abs(dStPtY - dEdPtY) < 0.1) {
    [pt1, pt2] = [pt2, pt1];
  } else if (dStPtY > dEdPtY && Math.abs(dStPtX - dEdPtX) < 0.1) {
    [pt1, pt2] = [pt2, pt1];
  }

  // 计算方向向量
  let dirLenTmp = { x: pt2.x - pt1.x, y: pt2.y - pt1.y, z: pt2.z - pt1.z };
  // 获取dirLen的单位向量
  let len = Math.sqrt(dirLenTmp.x * dirLenTmp.x + dirLenTmp.y * dirLenTmp.y);
  let dirLen = {
    x: dirLenTmp.x / len,
    y: dirLenTmp.y / len,
    z: dirLenTmp.z / len,
  };

  // 计算dirWidth
  let dirWidth = crossProduct(dirLen, { x: 0, y: 0, z: 1 });
  let dLength = distance(pt1, pt2);

  if (Ecc < 0) {
    Ecc += dLength;
    Ecc -= nHoleWidth;
  }

  if (Math.abs(nWallEcc) > 0) {
    pt1.x -= Math.abs(dirWidth.x) * nWallEcc;
    pt1.y += Math.abs(dirWidth.y) * nWallEcc;
  }

  // Calculate the distance from the start point for the wall hole
  let pt0 = {
    x: pt1.x - (dirWidth.x * nWallThick) / 2 + dirLen.x * Ecc,
    y: pt1.y - (dirWidth.y * nWallThick) / 2 + dirLen.y * Ecc,
    z: pt1.z - (dirWidth.z * nWallThick) / 2 + dirLen.z * Ecc,
  };

  // Assuming `getRectModelDesignData` is a function that you already have in JavaScript
  strRes = getRectModelDesignData(
    "modelWall",
    pt0,
    dirLen,
    dirWidth,
    nWallThick,
    nHoleWidth,
    nHoleHeight
  );

  return strRes;
};

//绘制板洞绘制数据
export const getPKPM_SlabHoleData = (
  nModelShapeType,
  strShapeData,
  dPtX,
  dPtY,
  dBotEle,
  dFloorHeight,
  dEccX,
  dEccY,
  dRotation,
  dSlabThick
) => {
  let strRes = "";
  if (nModelShapeType < 0) return strRes;
  if (!strShapeData) return strRes;

  let vecModelSizeData = strShapeData.split(",");
  let nSize = vecModelSizeData.length;
  if (nSize < 3) return strRes;

  let pt = { x: dPtX, y: dPtY, z: dBotEle + dFloorHeight };

  let dirLen = { x: 1, y: 0, z: 0 };
  let dirWidth = { x: 0, y: 1, z: 0 };

  pt.x += dirLen.x * dEccX;
  pt.y += dirWidth.y * dEccY;

  if (nModelShapeType === 1 && nSize === 5) {
    // Rectangle
    let dThick = parseFloat(vecModelSizeData[1]);
    let dWidth = parseFloat(vecModelSizeData[2]);

    let pt0 = { ...pt };
    pt0.x -= (dirLen.x * dThick) / 2;
    pt0.y -= (dirWidth.y * dWidth) / 2;

    strRes = getRectModelDesignData(
      "modelColum",
      pt0,
      dirLen,
      dirWidth,
      dWidth,
      dThick,
      dSlabThick,
      dRotation,
      pt
    );
  } else if (nModelShapeType === 3 && nSize === 4) {
    // Circle
    let dDiameter = parseFloat(vecModelSizeData[1]); // Diameter
    strRes = getCircleDesignData(pt, dDiameter / 2, dSlabThick);
  }

  return strRes;
};

//绘制圆弧拉伸模型数据
function getArcModelDesignData(
  type,
  ptSt,
  ptEd,
  ptCenter,
  dRadius,
  dHeight,
  dThick,
  dEcc,
  dRotation = 0,
  rotationCenter = { x: 0, y: 0, z: 0 },
  vecRotation = { x: 0, y: 0, z: 1 }
) {
  if (dHeight <= 0 || dThick <= 0 || dRadius <= 0) return "";

  let { outerArc, innerArc } = getOffsetArcPoints(
    ptSt,
    ptEd,
    ptCenter,
    dRadius,
    dThick / 2,
    dEcc
  );
  let outLastPt = outerArc[outerArc.length - 1];
  let inStartPt = innerArc[0];
  let dist = outLastPt.distanceTo(inStartPt);
  let points = outerArc;
  //如果内外圆弧的距离小于厚度，则将内圆弧反转
  if (Math.abs(dist - dThick) < 0.5) {
    points.push(...innerArc);
  } else {
    innerArc.reverse();
    points.push(...innerArc);
  }
  // 创建并绘制多段线
  // const polyline1 = new McDbPolyline();
  // points.forEach((pt) => {
  //   polyline1.addVertexAt(pt);
  // });
  // polyline1.trueColor = new McCmColor(255, 0, 0);
  // // 绘制多段线
  // rlAppObj.mxcadObject.drawEntity(polyline1);
  // 生成棱柱数据
  let { upViewData, drawData } = getMakePrismModelData(
    points,
    points,
    dHeight,
    dRotation,
    { x: 0, y: 0, z: -1 },
    rotationCenter,
    vecRotation
  );

  let sectData = "";
  //根据模型类型，添加不同的截面数据
  if (type === "modelBeam") {
    sectData += getSectData("B", dThick, pt0, pt1) + ",";
    let ptTmp = { ...pt0, z: pt1.z - dHeight };
    sectData += getSectData("H", dHeight, pt0, ptTmp);
  } else if (type === "modelWall") {
    sectData += getSectData("T", dThick, points[0], points[points.length - 1]);
  }

  let strRes = `{"upViewData":[${upViewData.replace(
    /"/g,
    ""
  )}],"SectData":[${sectData}],"Drawing_3D":${drawData}}`;
  return strRes;
}

//根据初始圆弧获取内外等距离偏移的圆弧
function getOffsetArcPoints(ptStart, ptEnd, ptCenter, dRadius, dOffset, dEcc) {
  // 计算内外偏移圆弧的点
  const getArcPoints = (radius) => {
    // 计算起始角度和结束角度
    const startAngle = Math.atan2(
      ptStart.y - ptCenter.y,
      ptStart.x - ptCenter.x
    );
    let endAngle = Math.atan2(ptEnd.y - ptCenter.y, ptEnd.x - ptCenter.x);

    // 确保endAngle大于startAngle
    if (endAngle < startAngle) {
      endAngle += 2 * Math.PI;
    }

    // 生成圆弧上的点
    const numPoints = 36; // 圆弧精度
    const points = [];
    for (let i = 0; i <= numPoints; i++) {
      const t = startAngle + ((endAngle - startAngle) * i) / numPoints;
      const x = ptCenter.x + radius * Math.cos(t);
      const y = ptCenter.y + radius * Math.sin(t);
      points.push(new McGePoint3d(x, y, ptStart.z));
    }
    return points;
  };

  // 获取外偏移圆弧点
  const outerPoints = getArcPoints(dRadius + dOffset + dEcc);

  // 获取内偏移圆弧点
  const innerPoints = getArcPoints(dRadius - dOffset + dEcc);

  return {
    outerArc: outerPoints,
    innerArc: innerPoints,
  };
}

export const getArcPoints = (ptStart, ptEnd, ptCenter, radius) => {
  // 计算起始角度和结束角度
  const startAngle = Math.atan2(ptStart.y - ptCenter.y, ptStart.x - ptCenter.x);
  let endAngle = Math.atan2(ptEnd.y - ptCenter.y, ptEnd.x - ptCenter.x);

  // 确保endAngle大于startAngle
  if (endAngle < startAngle) {
    endAngle += 2 * Math.PI;
  }

  // 生成圆弧上的点
  const numPoints = 36; // 圆弧精度
  const points = [];
  for (let i = 0; i <= numPoints; i++) {
    const t = startAngle + ((endAngle - startAngle) * i) / numPoints;
    const x = ptCenter.x + radius * Math.cos(t);
    const y = ptCenter.y + radius * Math.sin(t);
    points.push(new McGePoint3d(x, y, ptStart.z));
  }
  return points;
};

//绘制矩形拉伸模型数据
function getRectModelDesignData(
  type,
  pt0,
  dirX,
  dirY,
  dThick,
  dLength,
  dHeight,
  dRotation = 0,
  rotationCenter = { x: 0, y: 0, z: 0 },
  vecRotation = { x: 0, y: 0, z: 1 }
) {
  if (dThick <= 0 || dLength <= 0 || dHeight <= 0) {
    return "";
  }

  //vecX取单位向量
  let lenX = Math.sqrt(dirX.x * dirX.x + dirX.y * dirX.y);
  const vecX = {
    x: dirX.x / lenX,
    y: dirX.y / lenX,
    z: dirX.z / lenX,
  };
  //vecY取单位向量
  let lenY = Math.sqrt(dirY.x * dirY.x + dirY.y * dirY.y);
  const vecY = {
    x: dirY.x / lenY,
    y: dirY.y / lenY,
    z: dirY.z / lenY,
  };

  // Transformation functions
  function transformPoint(pt, dir, distance) {
    return {
      x: pt.x + dir.x * distance,
      y: pt.y + dir.y * distance,
      z: pt.z + dir.z * distance,
    };
  }

  // 计算矩形的四个角点
  const pt1 = transformPoint(pt0, vecX, dLength);
  const pt2 = transformPoint(pt1, vecY, dThick);
  const pt3 = transformPoint(pt0, vecY, dThick);

  // 将四个角点存入数组
  const vecPtData = [pt0, pt1, pt2, pt3];

  // 生成棱柱数据
  let { upViewData, drawData } = getMakePrismModelData(
    vecPtData,
    vecPtData,
    dHeight,
    dRotation,
    { x: 0, y: 0, z: -1 },
    rotationCenter,
    vecRotation
  );

  let sectData = "";
  // 根据模型类型，添加不同的截面数据
  if (type === "modelBeam") {
    sectData += getSectData("B", dThick, pt0, pt1) + ",";
    let ptTmp = { ...pt0, z: pt1.z - dHeight };
    sectData += getSectData("H", dHeight, pt0, ptTmp);
  } else if (type === "modelWall") {
    sectData += getSectData("T", dThick, pt0, pt1);
  } else if (type === "modelColum") {
    sectData += getSectData("B", dThick, pt0, pt1) + ",";
    let ptTmp = { ...pt0, z: pt3.z - dLength };
    sectData += getSectData("H", dLength, pt0, ptTmp);
  }

  let strRes = `{"upViewData":[${upViewData.replace(
    /"/g,
    ""
  )}],"SectData":[${sectData}],"Drawing_3D":${drawData}}`;

  // let strRes = JSON.stringify({
  //   upViewData: vecUpViewPtDataTmp,
  //   SectData: sectData,
  //   Drawing_3D: drawData,
  // });

  return strRes;
}

function getIShapeDesignData(
  pt0,
  vecX,
  vecY,
  dB,
  dH,
  dU,
  dT,
  dD,
  dF,
  dHeight,
  dRotation = 0,
  rotationCenter = { x: 0, y: 0, z: 0 },
  vecZ = { x: 0, y: 0, z: -1 }
) {
  if (
    dB <= 0 ||
    dH <= 0 ||
    dU <= 0 ||
    dT <= 0 ||
    dD <= 0 ||
    dF <= 0 ||
    dHeight <= 0
  )
    return "";

  let vecPtData = [
    { x: dB / 2, y: dH / 2 - dT, z: 0 },
    { x: dU / 2, y: dH / 2 - dT, z: 0 },
    { x: dU / 2, y: dH / 2, z: 0 },
    { x: -dU / 2, y: dH / 2, z: 0 },
    { x: -dU / 2, y: dH / 2 - dT, z: 0 },
    { x: -dB / 2, y: dH / 2 - dT, z: 0 },
    { x: -dB / 2, y: -dH / 2 + dF, z: 0 },
    { x: -dD / 2, y: -dH / 2 + dF, z: 0 },
    { x: -dD / 2, y: -dH / 2, z: 0 },
    { x: dD / 2, y: -dH / 2, z: 0 },
    { x: dD / 2, y: -dH / 2 + dF, z: 0 },
    { x: dB / 2, y: -dH / 2 + dF, z: 0 },
  ];

  let vecMove = { x: pt0.x, y: pt0.y, z: pt0.z };
  //偏移到pt0位置
  vecPtData.forEach((pt) => {
    pt.x += vecMove.x;
    pt.y += vecMove.y;
    pt.z += vecMove.z;
  });

  let vecUpViewPtData = vecPtData;
  //与Z轴不平行
  if (Math.abs(Math.abs(vecZ.z) - 1) > 0.001) {
    // 创建旋转矩阵
    const rotationMatrix = createCenterRotationMatrix(pt0, vecZ);
    vecPtData = vecPtData.map((pt) => rotatePoint3D(pt, rotationMatrix));

    // 将vecZ旋转到与z轴平行
    // let vecX = crossProduct(vecZ, { x: 0, y: 0, z: 1 });
    const rotationMatrix2 = createCenterRotationMatrix(pt0, vecX);
    vecPtData = vecPtData.map((pt) => rotatePoint3D(pt, rotationMatrix2));

    vecPtData.forEach((pt) => {
      pt.z -= dH / 2;
    });
    //如果vec与z轴不平行,绘制俯视图--矩形
    vecUpViewPtData = [
      {
        x: pt0.x - (vecX.x * dU) / 2,
        y: pt0.y - (vecX.y * dU) / 2,
        z: pt0.z,
      },
      {
        x: pt0.x + (vecX.x * dU) / 2,
        y: pt0.y + (vecX.y * dU) / 2,
        z: pt0.z,
      },
      {
        x: pt0.x + (vecX.x * dU) / 2 + vecZ.x * dHeight,
        y: pt0.y + (vecX.y * dU) / 2 + vecZ.y * dHeight,
        z: pt0.z,
      },
      {
        x: pt0.x - (vecX.x * dU) / 2 + vecZ.x * dHeight,
        y: pt0.y - (vecX.y * dU) / 2 + vecZ.y * dHeight,
        z: pt0.z,
      },
    ];
  }

  let { upViewData, drawData } = getMakePrismModelData(
    vecPtData,
    vecUpViewPtData,
    dHeight,
    0,
    vecZ
  );

  let sectData = "";
  sectData += getSectData("B", dB, vecPtData[6], vecPtData[11]) + ",";
  if (dU === dD) {
    sectData += getSectData("H", dH, vecPtData[2], vecPtData[9]) + ",";
  } else {
    let trsX = setTranslation(vecX, dH);
    let ptTmp = transformPoint(vecPtData[2], trsX);
    sectData += getSectData("H", dH, vecPtData[2], ptTmp) + ",";
  }
  sectData += getSectData("U", dU, vecPtData[2], vecPtData[3]) + ",";
  sectData += getSectData("T", dT, vecPtData[3], vecPtData[4]) + ",";
  sectData += getSectData("D", dD, vecPtData[8], vecPtData[9]) + ",";
  sectData += getSectData("F", dF, vecPtData[7], vecPtData[8]);

  let strRes = `{"upViewData":[${upViewData.replace(
    /"/g,
    ""
  )}],"SectData":[${sectData}],"Drawing_3D":${drawData}}`;

  return strRes;
}

//获取圆形截面的模型数据
function getCircleDesignData(
  ptCenter,
  dRedis,
  dHeight,
  vec = { x: 0, y: 0, z: -1 }
) {
  if (dRedis <= 0 || dHeight <= 0) {
    return "";
  }

  const nDivid = 16;
  const rotateAngPre = (2 * Math.PI) / nDivid;

  // 创建旋转矩阵
  const rotationMatrix = createCenterRotationMatrix(ptCenter, vec);

  const vecPtData = [];
  for (let i = 0; i < nDivid; i++) {
    const x = ptCenter.x + dRedis * Math.cos(rotateAngPre * i);
    const y = ptCenter.y + dRedis * Math.sin(rotateAngPre * i);
    const z = ptCenter.z;

    let ptTmp = { x: x, y: y, z: z };
    // 如果vec与z轴不平行，则将ptTmp以圆心为旋转中心，旋转到与z轴平行
    if (Math.abs(Math.abs(vec.z) - 1) > 0.001) {
      // 将点绕圆心旋转
      ptTmp = rotatePoint3D(ptTmp, rotationMatrix);
    }

    vecPtData.push(ptTmp);
  }

  let vecUpViewPtData = vecPtData;
  if (Math.abs(Math.abs(vec.z) - 1) > 0.001) {
    //如果vec与z轴不平行,绘制俯视图--矩形
    let vecX = crossProduct(vec, { x: 0, y: 0, z: -1 });
    vecUpViewPtData = [
      {
        x: ptCenter.x - vecX.x * dRedis,
        y: ptCenter.y - vecX.y * dRedis,
        z: ptCenter.z,
      },
      {
        x: ptCenter.x + vecX.x * dRedis,
        y: ptCenter.y + vecX.y * dRedis,
        z: ptCenter.z,
      },
      {
        x: ptCenter.x + vecX.x * dRedis + vec.x * dHeight,
        y: ptCenter.y + vecX.y * dRedis + vec.y * dHeight,
        z: ptCenter.z,
      },
      {
        x: ptCenter.x - vecX.x * dRedis + vec.x * dHeight,
        y: ptCenter.y - vecX.y * dRedis + vec.y * dHeight,
        z: ptCenter.z,
      },
    ];
  }

  let { upViewData, drawData } = getMakePrismModelData(
    vecPtData,
    vecUpViewPtData,
    dHeight,
    0,
    vec
  );
  // Add cross-section size data
  let sectData = "";
  let ptTmp1 = { x: ptCenter.x - dRedis, y: ptCenter.y, z: ptCenter.z };
  let ptTmp2 = { x: ptCenter.x + dRedis, y: ptCenter.y, z: ptCenter.z };
  sectData += getSectData("B", dRedis * 2, ptTmp1, ptTmp2);

  let strRes = `{"upViewData":[${upViewData.replace(
    /"/g,
    ""
  )}],"SectData":[${sectData}],"Drawing_3D":${drawData}}`;

  return strRes;
  // Uncomment the line below if you want to include 3D information.
  // strRes += WasmOcctView.get3dInfoWith2d(vecPtData, new gp_Dir(0, 0, -1), dHeight);
}

//获取正多边形截面的模型数据
function getRegularPolygonDesignData(
  pt0,
  dRedis,
  nEdgeCount,
  dHeight,
  dRotation = 0,
  vec = { x: 0, y: 0, z: -1 }
) {
  if (dRedis <= 0 || nEdgeCount <= 0 || dHeight <= 0) {
    return "";
  }

  // Initialization of variables
  const radius = dRedis; // radius
  const numSides = nEdgeCount; // number of polygon sides
  // 创建旋转矩阵
  const rotationMatrix = createCenterRotationMatrix(pt0, vec);
  const vecPtData = [];
  for (let i = 1; i <= numSides; i++) {
    const angle = (2 * Math.PI * (i - 1)) / numSides;
    const x = pt0.x + radius * Math.cos(angle);
    const y = pt0.y + radius * Math.sin(angle);
    const z = pt0.z;

    let ptTmp = { x, y, z };

    //如果vec与z轴不平行，则以pt0为旋转中心，进行旋转
    if (Math.abs(Math.abs(vec.z) - 1) > 0.001) {
      ptTmp = rotatePoint3D(ptTmp, rotationMatrix);
    }

    vecPtData.push(ptTmp);
  }
  let vecUpViewPtData = vecPtData;
  if (Math.abs(Math.abs(vec.z) - 1) > 0.001) {
    //如果vec与z轴不平行,绘制俯视图--矩形
    let vecX = crossProduct(vec, { x: 0, y: 0, z: 1 });
    vecUpViewPtData = [
      {
        x: pt0.x - vecX.x * dRedis,
        y: pt0.y - vecX.y * dRedis,
        z: pt0.z,
      },
      {
        x: pt0.x + vecX.x * dRedis,
        y: pt0.y + vecX.y * dRedis,
        z: pt0.z,
      },
      {
        x: pt0.x + vecX.x * dRedis + vec.x * dHeight,
        y: pt0.y + vecX.y * dRedis + vec.y * dHeight,
        z: pt0.z,
      },
      {
        x: pt0.x - vecX.x * dRedis + vec.x * dHeight,
        y: pt0.y - vecX.y * dRedis + vec.y * dHeight,
        z: pt0.z,
      },
    ];
  }
  // Prepare result string
  let { upViewData, drawData } = getMakePrismModelData(
    vecPtData,
    vecUpViewPtData,
    dHeight,
    dRotation,
    vec
  );
  // Add section data
  let sectData = "";

  const ptTmp1 = { x: pt0.x - radius, y: pt0.y, z: pt0.z };
  const ptTmp2 = { x: pt0.x + radius, y: pt0.y, z: pt0.z };
  sectData += getSectData("B", dRedis * 2, ptTmp1, ptTmp2);

  let strRes = `{"upViewData":[${upViewData.replace(
    /"/g,
    ""
  )}],"SectData":[${sectData}],"Drawing_3D":${drawData}}`;

  return strRes;
}

//获取十字工字型截面的模型数据
function getCrossIShapeDesignData(
  pt0,
  vecX,
  vecY,
  dB,
  dH,
  dT,
  dF,
  dU,
  dD,
  dL,
  dP,
  dHeight,
  dRotation = 0,
  vecZ = { x: 0, y: 0, z: -1 }
) {
  if (
    dB <= 0 ||
    dH <= 0 ||
    dT <= 0 ||
    dF <= 0 ||
    dU <= 0 ||
    dD <= 0 ||
    dL <= 0 ||
    dP <= 0 ||
    dHeight <= 0
  ) {
    return null;
  }

  let vecPtData = [
    { x: dD / 2, y: dP / 2, z: 0 },
    { x: dD / 2 - dL, y: dP / 2, z: 0 },
    { x: dD / 2 - dL, y: dU / 2, z: 0 },
    { x: dB / 2, y: dU / 2, z: 0 },
    { x: dB / 2, y: dH / 2 - dT, z: 0 },
    { x: dF / 2, y: dH / 2 - dT, z: 0 },
    { x: dF / 2, y: dH / 2, z: 0 },
    { x: -dF / 2, y: dH / 2, z: 0 },
    { x: -dF / 2, y: dH / 2 - dT, z: 0 },
    { x: -dB / 2, y: dH / 2 - dT, z: 0 },
    { x: -dB / 2, y: dU / 2, z: 0 },
    { x: -dD / 2 + dL, y: dU / 2, z: 0 },
    { x: -dD / 2 + dL, y: dP / 2, z: 0 },
    { x: -dD / 2, y: dP / 2, z: 0 },
    { x: -dD / 2, y: -dP / 2, z: 0 },
    { x: -dD / 2 + dL, y: -dP / 2, z: 0 },
    { x: -dD / 2 + dL, y: -dU / 2, z: 0 },
    { x: -dB / 2, y: -dU / 2, z: 0 },
    { x: -dB / 2, y: -dH / 2 + dT, z: 0 },
    { x: -dF / 2, y: -dH / 2 + dT, z: 0 },
    { x: -dF / 2, y: -dH / 2, z: 0 },
    { x: dF / 2, y: -dH / 2, z: 0 },
    { x: dF / 2, y: -dH / 2 + dT, z: 0 },
    { x: dB / 2, y: -dH / 2 + dT, z: 0 },
    { x: dB / 2, y: -dU / 2, z: 0 },
    { x: dD / 2 - dL, y: -dU / 2, z: 0 },
    { x: dD / 2 - dL, y: -dP / 2, z: 0 },
    { x: dD / 2, y: -dP / 2, z: 0 },
  ];

  let vecMove = { x: pt0.x, y: pt0.y, z: pt0.z };
  //偏移到pt0位置
  vecPtData.forEach((pt) => {
    pt.x += vecMove.x;
    pt.y += vecMove.y;
    pt.z += vecMove.z;
  });

  // 将vecPtData旋转dRotation度
  if (dRotation > 0) {
    const rotationMatrix = createRotationMatrix(pt0, dRotation);
    vecPtData = vecPtData.map((pt) => rotatePoint(pt, rotationMatrix));
  }

  let vecUpViewPtData = vecPtData;
  // 如果vecZ与z轴不平行，则进行旋转
  if (Math.abs(Math.abs(vecZ.z) - 1) > 0.001) {
    const rotationMatrix = createCenterRotationMatrix(pt0, vecZ);
    vecPtData = vecPtData.map((pt) => rotatePoint3D(pt, rotationMatrix));
    //如果vec与z轴不平行,绘制俯视图--矩形
    let vecX = crossProduct(vecZ, { x: 0, y: 0, z: 1 });
    vecUpViewPtData = [
      {
        x: pt0.x - (vecX.x * dH) / 2,
        y: pt0.y - (vecX.y * dH) / 2,
        z: pt0.z,
      },
      {
        x: pt0.x + (vecX.x * dH) / 2,
        y: pt0.y + (vecX.y * dH) / 2,
        z: pt0.z,
      },
      {
        x: pt0.x + (vecX.x * dH) / 2 + vecZ.x * dHeight,
        y: pt0.y + (vecX.y * dH) / 2 + vecZ.y * dHeight,
        z: pt0.z,
      },
      {
        x: pt0.x - (vecX.x * dH) / 2 + vecZ.x * dHeight,
        y: pt0.y - (vecX.y * dH) / 2 + vecZ.y * dHeight,
        z: pt0.z,
      },
    ];
  }

  let { upViewData, drawData } = getMakePrismModelData(
    vecPtData,
    vecUpViewPtData,
    dHeight,
    0,
    vecZ
  );

  let sectData = "";
  sectData += getSectData("B", dB, vecPtData[18], vecPtData[23]) + ",";
  let trsX = { x: (vecX.x * dD) / 2 + 200, y: (vecX.y * dD) / 2 + 200 }; // setTranslation(vecX, dD / 2 + 200);
  let ptTmp1 = { x: vecPtData[21].x + trsX.x, y: vecPtData[21].y + trsX.y }; // transformPoint(vecPtData[21], trsX);
  let ptTmp2 = { x: vecPtData[6].x + trsX.x, y: vecPtData[6].y + trsX.y }; // transformPoint(vecPtData[6], trsX);
  sectData += getSectData("H", dH, ptTmp1, ptTmp2) + ",";
  sectData += getSectData("U", dU, vecPtData[3], vecPtData[4]) + ",";
  sectData += getSectData("T", dT, vecPtData[4], vecPtData[5]) + ",";
  sectData += getSectData("D", dD, vecPtData[12], vecPtData[13]) + ",";
  sectData += getSectData("F", dF, vecPtData[10], vecPtData[11]);

  let strRes = `{"upViewData":[${upViewData.replace(
    /"/g,
    ""
  )}],"SectData":[${sectData}],"Drawing_3D":${drawData}}`;

  return strRes;
}

//获取矩形截面模型数据
function getIrrRectDesignData(
  pt0,
  dirX,
  dirY,
  dB,
  dH1,
  dH2,
  dThick,
  dirZ = { x: 0, y: 0, z: -1 }
) {
  if (dB <= 0 || dH1 <= 0 || dH2 <= 0 || dThick <= 0) {
    return "";
  }

  // Convert directions to Three.js Vectors
  const vecX = { x: dirX.x, y: dirX.y, z: dirX.z };
  const vecY = { x: dirY.x, y: dirY.y, z: dirY.z };
  const vecZ = { x: dirZ.x, y: dirZ.y, z: dirZ.z };

  // Define transformations (translations)
  const trsX = { x: vecX.x * dB, y: vecX.y * dB, z: vecX.z * dB }; //  new THREE.Matrix4().makeTranslation(vecX.multiplyScalar(dB));
  const trsY1 = { x: vecY.x * dH1, y: vecY.y * dH1, z: vecY.z * dH1 }; // new THREE.Matrix4().makeTranslation(vecY.multiplyScalar(dH1));
  const trsY2 = { x: vecY.x * dH2, y: vecY.y * dH2, z: vecY.z * dH2 }; // new THREE.Matrix4().makeTranslation(vecY.multiplyScalar(dH2));
  const trsZ = { x: vecZ.x * dThick, y: vecZ.y * dThick, z: vecZ.z * dThick }; // new THREE.Matrix4().makeTranslation(vecZ.multiplyScalar(dThick));

  // Apply transformations to points
  const pt1 = { x: pt0.x + trsX.x, y: pt0.y + trsX.y, z: pt0.z + trsX.z }; // pt0.clone().applyMatrix4(trsX);
  const pt2 = { x: pt1.x + trsY2.x, y: pt1.y + trsY2.y, z: pt1.z + trsY2.z }; // pt1.clone().applyMatrix4(trsY2);
  const pt3 = { x: pt0.x + trsY1.x, y: pt0.y + trsY1.y, z: pt0.z + trsY1.z }; // pt0.clone().applyMatrix4(trsY1);

  // Define a vector of points for the base rectangle
  const vecPtData = [pt0, pt1, pt2, pt3];

  const pt0_up = { x: pt0.x, y: pt0.y, z: pt0.z };
  // Points for the top rectangle, after applying the Z transformation
  const pt1_up = {
    x: pt0.x + trsX.x,
    y: pt0.y + trsX.y,
    z: pt0.z + trsX.z,
  }; // pt0.clone().applyMatrix4(trsX).applyMatrix4(trsZ);
  const pt2_up = { x: pt1.x + trsZ.x, y: pt1.y + trsZ.y, z: pt1.z + trsZ.z }; // pt1.clone().applyMatrix4(trsZ);
  const pt3_up = { x: pt0.x + trsZ.x, y: pt0.y + trsZ.y, z: pt0.z + trsZ.z }; // pt0.clone().applyMatrix4(trsZ);

  const vecUpViewPtData = [pt0_up, pt1_up, pt2_up, pt3_up];

  let { upViewData, drawData } = getMakePrismModelData(
    vecPtData,
    vecUpViewPtData,
    dThick,
    0,
    dirZ
  );

  let strRes = `{"upViewData":[${upViewData.replace(
    /"/g,
    ""
  )}],"SectData":[],"Drawing_3D":${drawData}}`;

  return strRes;
}

//获取矩形管截面模型数据
function getRectTubeDesignData(
  pt0,
  vecX,
  vecY,
  dWidth,
  dLength,
  dThickTop,
  dThickLeft,
  dThickBot,
  dThickRight,
  dHeight,
  dRotation = 0,
  vecZ = { x: 0, y: 0, z: -1 }
) {
  if (
    dWidth <= 0 ||
    dLength <= 0 ||
    dThickTop <= 0 ||
    dThickLeft <= 0 ||
    dThickBot <= 0 ||
    dThickRight <= 0 ||
    dHeight <= 0
  ) {
    return "";
  }

  // Collect points for the profile (section) of the shape
  let vecPtData = [];
  vecPtData.push(
    new THREE.Vector3(dWidth / 2 - dThickRight, dLength / 2 - dThickTop, 0)
  );
  vecPtData.push(
    new THREE.Vector3(-dWidth / 2 + dThickLeft, dLength / 2 - dThickTop, 0)
  );
  vecPtData.push(
    new THREE.Vector3(-dWidth / 2 + dThickLeft, -dLength / 2 + dThickBot, 0)
  );
  vecPtData.push(
    new THREE.Vector3(dWidth / 2 - dThickRight, -dLength / 2 + dThickBot, 0)
  );
  vecPtData.push(
    new THREE.Vector3(dWidth / 2 - dThickRight, dLength / 2 - dThickTop, 0)
  );

  vecPtData.push(new THREE.Vector3(dWidth / 2, dLength / 2, 0));
  vecPtData.push(new THREE.Vector3(-dWidth / 2, dLength / 2, 0));
  vecPtData.push(new THREE.Vector3(-dWidth / 2, -dLength / 2, 0));
  vecPtData.push(new THREE.Vector3(dWidth / 2, -dLength / 2, 0));
  vecPtData.push(new THREE.Vector3(dWidth / 2, dLength / 2, 0));
  let vecMove = { x: pt0.x, y: pt0.y, z: pt0.z };
  //偏移到pt0位置
  vecPtData.forEach((pt) => {
    pt.x += vecMove.x;
    pt.y += vecMove.y;
    pt.z += vecMove.z;
  });

  console.log("vecPtData", vecPtData);

  let vecUpViewPtData = vecPtData;
  // Check if the Z direction is parallel to the default direction
  if (Math.abs(Math.abs(vecZ.z) - 1) > 0.001) {
    const rotationMatrixTmp = createCenterRotationMatrix(pt0, vecZ);
    vecPtData = vecPtData.map((pt) => rotatePoint3D(pt, rotationMatrixTmp));

    // 将vecZ旋转到与z轴平行
    let vecX = crossProduct(vecZ, { x: 0, y: 0, z: 1 });
    const rotationMatrix2 = createCenterRotationMatrix(pt0, vecY);
    vecPtData = vecPtData.map((pt) => rotatePoint3D(pt, rotationMatrix2));

    vecPtData.forEach((pt) => {
      pt.z -= dLength;
    });

    //平面图设置
    vecUpViewPtData = [
      {
        x: pt0.x - (vecX.x * dWidth) / 2,
        y: pt0.y - (vecX.y * dWidth) / 2,
        z: pt0.z,
      },
      {
        x: pt0.x + vecZ.x * dHeight - (vecX.x * dWidth) / 2,
        y: pt0.y + vecZ.y * dHeight - (vecX.y * dWidth) / 2,
        z: pt0.z,
      },
      {
        x: pt0.x + vecZ.x * dHeight + (vecX.x * dWidth) / 2,
        y: pt0.y + vecZ.y * dHeight + (vecX.y * dWidth) / 2,
        z: pt0.z,
      },
      {
        x: pt0.x + (vecX.x * dWidth) / 2,
        y: pt0.y + (vecX.y * dWidth) / 2,
        z: pt0.z,
      },
      {
        x: pt0.x - (vecX.x * dWidth) / 2,
        y: pt0.y - (vecX.y * dWidth) / 2,
        z: pt0.z,
      },
      {
        x: pt0.x - (vecX.x * dWidth) / 2 - vecX.x * dThickLeft,
        y: pt0.y - (vecX.y * dWidth) / 2 - vecX.y * dThickLeft,
        z: pt0.z,
      },
      {
        x:
          pt0.x +
          vecZ.x * dHeight -
          (vecX.x * dWidth) / 2 -
          vecX.x * dThickLeft,
        y:
          pt0.y +
          vecZ.y * dHeight -
          (vecX.y * dWidth) / 2 -
          vecX.y * dThickLeft,
        z: pt0.z,
      },
      {
        x:
          pt0.x +
          vecZ.x * dHeight +
          (vecX.x * dWidth) / 2 -
          vecX.x * dThickLeft,
        y:
          pt0.y +
          vecZ.y * dHeight +
          (vecX.y * dWidth) / 2 -
          vecX.y * dThickLeft,
        z: pt0.z,
      },
      {
        x: pt0.x + (vecX.x * dWidth) / 2 - vecX.x * dThickLeft,
        y: pt0.y + (vecX.y * dWidth) / 2 - vecX.y * dThickLeft,
        z: pt0.z,
      },
      {
        x: pt0.x - (vecX.x * dWidth) / 2 - vecX.x * dThickLeft,
        y: pt0.y - (vecX.y * dWidth) / 2 - vecX.y * dThickLeft,
        z: pt0.z,
      },
    ];
  }

  if (dRotation > 0) {
    // 将vecPtData旋转dRotation度
    const rotationMatrix = createRotationMatrix(pt0, dHeight, dRotation);
    vecPtData = vecPtData.map((pt) => rotatePoint(pt, rotationMatrix));
  }

  // Prepare result data for the response
  let { upViewData, drawData } = getMakePrismModelData(
    vecPtData,
    vecUpViewPtData,
    dHeight,
    0,
    vecZ
  );

  let sectData = "";
  sectData += getSectData("B", dWidth, vecPtData[6], vecPtData[7]) + ",";
  sectData += getSectData("H", dLength, vecPtData[7], vecPtData[4]) + ",";

  const trsX = {
    x: vecX.x * dThickLeft,
    y: vecX.y * dThickLeft,
    z: vecX.z * dThickLeft,
  };
  // new THREE.Matrix4().makeTranslation(
  //   vecXTmp.multiplyScalar(dThickLeft)
  // );
  const ptTmp1 = {
    x: vecPtData[4].x + trsX.x,
    y: vecPtData[4].y + trsX.y,
    z: vecPtData[4].z + trsX.z,
  }; //vecPtData[4].clone().applyMatrix4(trsX);
  sectData += getSectData("T", dThickLeft, vecPtData[4], ptTmp1) + ",";

  const trsY = {
    x: vecY.x * dThickTop,
    y: vecY.y * dThickTop,
    z: vecY.z * dThickTop,
  };
  // new THREE.Matrix4().makeTranslation(
  //   vecYTmp.multiplyScalar(dThickTop)
  // );
  const ptTmp2 = {
    x: vecPtData[7].x + trsY.x,
    y: vecPtData[7].y + trsY.y,
    z: vecPtData[7].z + trsY.z,
  }; //vecPtData[7].clone().applyMatrix4(trsY);
  sectData += getSectData("U", dThickTop, vecPtData[7], ptTmp2);

  let strRes = `{"upViewData":[${upViewData.replace(
    /"/g,
    ""
  )}],"SectData":[${sectData}],"Drawing_3D":${drawData}}`;

  return strRes;
}

//获取L型截面模型数据
function getLShapeDesignData(
  pt0,
  dB,
  dH,
  dD,
  dF,
  dHeight,
  dRotation = 0,
  vec = { x: 0, y: 0, z: -1 }
) {
  if (dB <= 0 || dH <= 0 || dD <= 0 || dF <= 0 || dHeight <= 0) {
    return "";
  }

  let vecPtData = [];
  vecPtData.push({ x: dB / 2, y: -dF / 2, z: 0 });
  vecPtData.push({ x: dB / 2, y: dH - dF / 2, z: 0 });
  vecPtData.push({ x: -dB / 2, y: dH - dF / 2, z: 0 });
  vecPtData.push({ x: -dB / 2, y: dF / 2, z: 0 });
  vecPtData.push({ x: -dB / 2 - dD, y: dF / 2, z: 0 });
  vecPtData.push({ x: -dB / 2 - dD, y: -dF / 2, z: 0 });

  let vecMove = { x: pt0.x, y: pt0.y, z: pt0.z };
  //偏移到pt0位置
  vecPtData.forEach((pt) => {
    pt.x += vecMove.x;
    pt.y += vecMove.y;
    pt.z += vecMove.z;
  });

  // 将vecPtData旋转dRotation度
  if (dRotation > 0) {
    const rotationMatrix = createRotationMatrix(pt0, dRotation);
    vecPtData = vecPtData.map((pt) => rotatePoint(pt, rotationMatrix));
  }

  let { upViewData, drawData } = getMakePrismModelData(
    vecPtData,
    vecPtData,
    dHeight,
    0,
    vec
  );

  let strRes = `{"upViewData":[${upViewData.replace(
    /"/g,
    ""
  )}],"SectData":[],"Drawing_3D":${drawData}}`;

  return strRes;
}

//获取T型截面模型数据
function getTShapeDesignData(
  pt0,
  dB,
  dH,
  dD,
  dF,
  dHeight,
  dRotation = 0,
  vec = { x: 0, y: 0, z: -1 }
) {
  if (dB <= 0 || dH <= 0 || dD <= 0 || dF <= 0 || dHeight <= 0) {
    return "";
  }

  let vecPtData = [];
  vecPtData.push({ x: dD / 2, y: -dF / 2, z: 0 });
  vecPtData.push({ x: dD / 2, y: dF / 2, z: 0 });
  vecPtData.push({ x: dB / 2, y: dF / 2, z: 0 });
  vecPtData.push({ x: dB / 2, y: dH - dF / 2, z: 0 });
  vecPtData.push({ x: -dB / 2, y: dH - dF / 2, z: 0 });
  vecPtData.push({ x: -dB / 2, y: dF / 2, z: 0 });
  vecPtData.push({ x: -dD / 2, y: dF / 2, z: 0 });
  vecPtData.push({ x: -dD / 2, y: -dF / 2, z: 0 });

  let vecMove = { x: pt0.x, y: pt0.y, z: pt0.z };
  //偏移到pt0位置
  vecPtData.forEach((pt) => {
    pt.x += vecMove.x;
    pt.y += vecMove.y;
    pt.z += vecMove.z;
  });

  // 将vecPtData旋转dRotation度
  const rotationMatrix = createRotationMatrix(pt0, dRotation);
  vecPtData = vecPtData.map((pt) => rotatePoint(pt, rotationMatrix));

  let { upViewData, drawData } = getMakePrismModelData(
    vecPtData,
    vecPtData,
    dHeight,
    0,
    vec
  );

  let strRes = `{"upViewData":[${upViewData.replace(
    /"/g,
    ""
  )}],"SectData":[],"Drawing_3D":${drawData}}`;

  return strRes;
}

//型钢--L型
function getSteelLShapeDesignData(
  pt0,
  vecX,
  vecY,
  dB,
  dT,
  dHeight,
  dRotation = 0,
  vec = { x: 0, y: 0, z: -1 }
) {
  if (dB <= 0 || dT <= 0 || dHeight <= 0) {
    return "";
  }

  let vecPtData = [];
  vecPtData.push({ x: 0 - 20, y: 0 - 20, z: 0 });
  vecPtData.push({ x: dB - 20, y: 0 - 20, z: 0 });
  vecPtData.push({ x: dB - 20, y: dT - 20, z: 0 });
  vecPtData.push({ x: dT - 20, y: dT - 20, z: 0 });
  vecPtData.push({ x: dT - 20, y: dB - 20, z: 0 });
  vecPtData.push({ x: 0 - 20, y: dB - 20, z: 0 });
  // vecPtData.push({ x: 0, y: 0, z: 0 });

  let vecMove = { x: pt0.x, y: pt0.y, z: pt0.z };
  //偏移到pt0位置
  vecPtData.forEach((pt) => {
    pt.x += vecMove.x;
    pt.y += vecMove.y;
    pt.z += vecMove.z;
  });

  let vecUpViewPtData = vecPtData;
  if (Math.abs(Math.abs(vec.z) - 1) > 0.001) {
    // 创建旋转矩阵
    const rotationMatrix = createCenterRotationMatrix(pt0, vec);
    vecPtData = vecPtData.map((pt) => rotatePoint3D(pt, rotationMatrix));

    // 将vecZ旋转到与z轴平行
    // let vecX = crossProduct(vec, { x: 0, y: 0, z: 1 });
    const rotationMatrix2 = createCenterRotationMatrix(pt0, vecY);
    vecPtData = vecPtData.map((pt) => rotatePoint3D(pt, rotationMatrix2));

    vecUpViewPtData = [
      {
        x: pt0.x - (vecX.x * dB) / 2,
        y: pt0.y - (vecX.y * dB) / 2,
        z: pt0.z,
      },
      {
        x: pt0.x - (vecX.x * dB) / 2 + vec.x * dHeight,
        y: pt0.y - (vecX.y * dB) / 2 + vec.y * dHeight,
        z: pt0.z,
      },
      {
        x: pt0.x + (vecX.x * dB) / 2 + vec.x * dHeight,
        y: pt0.y + (vecX.y * dB) / 2 + vec.y * dHeight,
        z: pt0.z,
      },
      {
        x: pt0.x + (vecX.x * dB) / 2,
        y: pt0.y + (vecX.y * dB) / 2,
        z: pt0.z,
      },
    ];
  }

  // 将vecPtData旋转dRotation度
  if (dRotation > 0) {
    const rotationMatrix = createRotationMatrix(pt0, dRotation);
    vecPtData = vecPtData.map((pt) => rotatePoint(pt, rotationMatrix));
  }

  let { upViewData, drawData } = getMakePrismModelData(
    vecPtData,
    vecUpViewPtData,
    dHeight,
    0,
    vec
  );

  let strRes = `{"upViewData":[${upViewData.replace(
    /"/g,
    ""
  )}],"SectData":[],"Drawing_3D":${drawData}}`;

  return strRes;
}

//获取拉伸模型数据
function getMakePrismModelData(
  vecPrismPtData,
  vecUpViewPtData,
  dHeight,
  dRotation,
  vec = { x: 0, y: 0, z: -1 },
  rotationCenter = { x: 0, y: 0, z: 0 },
  vecRotation = { x: 0, y: 0, z: 0 }
) {
  const nSize = vecPrismPtData.length;
  if (nSize < 3) return "";

  let vecPrismPtDataTmp = [...vecPrismPtData]; // Create a copy
  let vecUpViewPtDataTmp = [...vecUpViewPtData];

  // Apply rotation if dRotation is greater than 0
  if (dRotation > 0) {
    const rotationMatrix = createRotationMatrix(rotationCenter, dRotation);

    // Rotate the prism points
    vecPrismPtDataTmp = vecPrismPtDataTmp.map((pt) =>
      rotatePoint(pt, rotationMatrix)
    );
    vecUpViewPtDataTmp = vecUpViewPtDataTmp.map((pt) =>
      rotatePoint(pt, rotationMatrix)
    );
  }

  let drawData = createPrismModel(vecPrismPtDataTmp, vec, dHeight);
  //将vecUpViewPtDataTmp转成[9127,3841,5000,18372,3841,5000,18372,4041,5000,9127,4041,5000]格式
  let upViewData = vecUpViewPtDataTmp.map((item) => {
    return item.x + "," + item.y + "," + item.z;
  });
  upViewData = upViewData.join(",");
  return { upViewData, drawData };
}

//创建旋转矩阵
function createRotationMatrix(center, angle) {
  const radians = angle * (Math.PI / 180); // Convert to radians
  return {
    cos: Math.cos(radians),
    sin: Math.sin(radians),
    centerX: center.x,
    centerY: center.y,
  };
}
//创建中心旋转矩阵
function createCenterRotationMatrix(center, vec) {
  // 计算旋转轴（vec与z轴的叉积）
  const rotationAxis = crossProduct(vec, { x: 0, y: 0, z: 1 });
  // 计算旋转角度（vec与z轴的夹角）
  const angle = Math.acos(vec.z);

  // 创建旋转矩阵
  const rotationMatrix = {
    cos: Math.cos(angle),
    sin: Math.sin(angle),
    axis: rotationAxis,
    center: center, //旋转中心
  };
  return rotationMatrix;
}

//旋转点
function rotatePoint(pt, matrix) {
  const { cos, sin, centerX, centerY } = matrix;

  // Translate point back to origin
  const dx = pt.x - centerX;
  const dy = pt.y - centerY;

  // Apply rotation
  const newX = cos * dx - sin * dy + centerX;
  const newY = sin * dx + cos * dy + centerY;

  return { x: newX, y: newY, z: pt.z }; // Z remains unchanged for 2D rotation
}

// 新增：3D旋转点的函数
function rotatePoint3D(pt, matrix) {
  const { cos, sin, axis, center } = matrix;

  // 将点移动到原点
  const dx = pt.x - center.x;
  const dy = pt.y - center.y;
  const dz = pt.z - center.z;

  // 罗德里格旋转公式 (Rodrigues' rotation formula)
  const dot = axis.x * dx + axis.y * dy + axis.z * dz;
  const cross = {
    x: axis.y * dz - axis.z * dy,
    y: axis.z * dx - axis.x * dz,
    z: axis.x * dy - axis.y * dx,
  };

  // 应用旋转
  return {
    x: center.x + dx * cos + cross.x * sin + axis.x * dot * (1 - cos),
    y: center.y + dy * cos + cross.y * sin + axis.y * dot * (1 - cos),
    z: center.z + dz * cos + cross.z * sin + axis.z * dot * (1 - cos),
  };
}

//获取截面数据
function getSectData(strKey, nSize, pt1, pt2) {
  // Start the result string with the key and a comma
  let strRes = `["${strKey},`;

  // Construct the string with the size and point coordinates
  strRes += `${Math.floor(nSize)},${pt1.x},${pt1.y},${pt1.z},${pt2.x},${
    pt2.y
  },${pt2.z}"]`;

  return strRes;
}

//计算两个向量的叉积
function crossProduct(v1, v2) {
  if (Math.abs(v1.z) < 0.01 && Math.abs(v2.z) < 0.01) {
    return v1.x * v2.y - v1.y * v2.x;
  }
  return {
    x: v1.y * v2.z - v1.z * v2.y,
    y: v1.z * v2.x - v1.x * v2.z,
    z: v1.x * v2.y - v1.y * v2.x,
  };
}

//计算两个点之间的距离
function distance(pt1, pt2) {
  return Math.sqrt(
    Math.pow(pt2.x - pt1.x, 2) +
      Math.pow(pt2.y - pt1.y, 2) +
      Math.pow(pt2.z - pt1.z, 2)
  );
}
